import Transform from "@ember-data/serializer/transform";
import DiabguideRecommendation, { DiabguideRecommendationArgs } from "core/models/diabguide-recommendation";
export default class DiabguideRecommendationTransform extends Transform {
  deserialize(serialized) {
    if (!serialized) return undefined;
    return new DiabguideRecommendation(serialized);
  }
  serialize(deserialized) {
    if (!deserialized) return undefined;
    return deserialized.serialize();
  }
}